// Cards row shared by /shipping and /custom-photo-holiday-cards so both show the same dates.
// Production days come from the SKU manifest through the products API (see withProduction).
export const CARDS_SHIPPING = {
  name: 'Cards and holiday cards',
  sku: 'holiday-cards',
  carrier: 'usps',
  holidayGroup: 'standardProducts',
};
